"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsBsKvsHiraganaQuiz = void 0;
var index_1 = require("../index");
/**
 * ひらがなクイズ
 *
 * @class CsBsKvsHiraganaQuiz
 */
var CsBsKvsHiraganaQuiz = /** @class */ (function () {
    /**
     * Creates an instance of CsBsKvsHiraganaQuiz.
     * @param {string} monthly
     * @memberof CsBsKvsHiraganaQuiz
     */
    /**
     * Creates an instance of CsBsKvsHiraganaQuiz.
     * @param {string} authinsideid こどもの共通顧客番号
     * @param {string} monthly 対象年月
     * @memberof CsBsKvsHiraganaQuiz
     */
    function CsBsKvsHiraganaQuiz(authinsideid, monthly) {
        // resultの定数
        this.RESULT_CORRECT = '1'; // 正解
        this.RESULT_HINT = '2'; // ヒントあり正解
        // app_id
        this.app_id = 'simac';
        // 1ステージ辺りの問題数
        this.questionNum = 5;
        this.authinsideid = authinsideid == '' ? undefined : authinsideid;
        this.monthly = monthly;
        if (!monthly) {
            throw new Error("CsBsKvsHiraganaQuiz:monthly\u304C\u6307\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002");
        }
        var debug = index_1.Location.getUrlVars()['debug'];
        var stage = index_1.Location.getUrlVars()['stage'];
        var panel_id = index_1.Location.getUrlVars()['panel_id'];
        var local_emulator = index_1.Location.getUrlVars()['local_emulator'];
        var local_storage = index_1.Location.getUrlVars()['local_storage'];
        if ((debug && (stage || panel_id)) || (stage && panel_id)) {
            // デバッグ用
            // 通信を行わない：localStorageにログを保存
            this.csbskvs =
                local_storage == 'true' ? new index_1.CsBsKvsDebug(true) : new index_1.CsBsKvsNoImp();
        }
        else if (local_emulator == 'true') {
            // デバッグ用
            // 通信を行わない：localStorageにログを保存
            this.csbskvs =
                local_storage == 'true' ? new index_1.CsBsKvsDebug() : new index_1.CsBsKvsNoImp();
        }
        else {
            // 通信を行う
            this.csbskvs = new index_1.CsBsKvs();
        }
        // 初期化
        this.progressDataName = 'hiragana_' + this.monthly;
        this.progressData = {
            data_name: this.progressDataName,
        };
        this.resultDataName = 'hiragana_result_' + this.monthly;
        this.resultData = {
            data_name: this.resultDataName,
        };
    }
    /**
     * 読み込み
     *
     * @return {*}  {Promise<void>}
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var param, data, debug, stage, panel_id;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        param = {
                            app_id: this.app_id,
                            user_key: this.authinsideid,
                            key_values: [
                                {
                                    data_name: 'hiragana_' + this.monthly,
                                },
                                {
                                    data_name: 'hiragana_result_' + this.monthly,
                                },
                            ],
                        };
                        if (param.user_key == undefined)
                            delete param.user_key;
                        return [4 /*yield*/, this.csbskvs.get(param)
                            // progressとresultを別々に保持
                        ];
                    case 1:
                        data = _a.sent();
                        // progressとresultを別々に保持
                        data.key_values.forEach(function (key_value) {
                            if (key_value.data_name == _this.progressDataName) {
                                _this.progressData = key_value;
                            }
                            if (key_value.data_name == _this.resultDataName) {
                                _this.resultData = key_value;
                            }
                        });
                        debug = index_1.Location.getUrlVars()['debug'];
                        stage = index_1.Location.getUrlVars()['stage'];
                        panel_id = index_1.Location.getUrlVars()['panel_id'];
                        if ((debug && (stage || panel_id)) || (stage && panel_id)) {
                            if (panel_id)
                                this.updatePanelId(parseInt(panel_id, 10));
                            // ステージが進んでる状態にする
                            if (stage && parseInt(stage, 10)) {
                                this.setResult(parseInt(stage, 10) * this.questionNum, 'X', 1, // ヒントあり=2、なし=1
                                1);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 読み込み
     *
     * @return {*}  {Promise<void>}
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.post = function () {
        return __awaiter(this, void 0, void 0, function () {
            var param;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // setResult() 内でディレーを付けている部分があるので開始を待つ
                    return [4 /*yield*/, index_1.Timer.wait(1)];
                    case 1:
                        // setResult() 内でディレーを付けている部分があるので開始を待つ
                        _a.sent();
                        param = {
                            app_id: this.app_id,
                            user_key: this.authinsideid,
                            key_values: [],
                        };
                        if (param.user_key == undefined)
                            delete param.user_key;
                        // データが空でなければ更新に含める
                        if (this.progressData.key_value &&
                            JSON.stringify(this.progressData.key_value) !== '{}') {
                            param.key_values.push(this.progressData);
                        }
                        if (this.resultData.key_value &&
                            JSON.stringify(this.resultData.key_value) !== '{}') {
                            param.key_values.push(this.resultData);
                        }
                        return [4 /*yield*/, this.csbskvs.put(param)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * panel_idを更新
     *
     * @param {number} panelId パネル番号
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.updatePanelId = function (panelId) {
        if (!Number.isNaN(panelId)) {
            if (!this.progressData.key_value) {
                this.progressData.key_value = {};
            }
            this.updateProgress();
            this.progressData.key_value.panel_id = String(panelId);
        }
    };
    /**
     * 設定されているpanel_idを返します
     *
     * @return {*}  {(number | undefined)} パネル番号
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.getPanelId = function () {
        var _a;
        var panelIdStr = (_a = this.progressData.key_value) === null || _a === void 0 ? void 0 : _a.panel_id;
        var panelId = undefined;
        if (panelIdStr !== undefined) {
            panelId = parseInt(panelIdStr, 10);
        }
        return panelId;
    };
    /**
     * 月号深度情報を更新する
     *
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.updateProgress = function () {
        var _this = this;
        var correctNum = 0;
        var tipsNum = 0;
        if (this.resultData.key_value) {
            var kv_1 = this.resultData.key_value;
            var mapData_1 = {};
            Object.keys(kv_1).forEach(function (key) {
                // kana_に絞る
                var found = key.match(/^kana_/);
                if (found) {
                    // 問題番号
                    var indexStr = key.replace(/[^0-9]/g, '');
                    if (indexStr) {
                        var index = parseInt(indexStr, 10);
                        var kana = kv_1['kana_' + String(indexStr)];
                        var result = kv_1['result_' + String(indexStr)];
                        if (mapData_1[kana] && mapData_1[kana].index > index) {
                            // すでに存在する
                            // 存在するデータより問題番号が若い
                            // → skip
                        }
                        else {
                            mapData_1[kana] = {
                                index: index,
                                result: result,
                            };
                        }
                    }
                }
            });
            // 登録数を数える：全回答で46になる
            // let count = 0
            // Object.keys(mapData).forEach((key) => {
            //   console.log(key + '' + mapData[key].result)
            //   count++
            // })
            // console.log(count)
            Object.keys(mapData_1).forEach(function (key) {
                // console.log(key + '' + mapData[key].result)
                if (mapData_1[key].result == _this.RESULT_HINT)
                    tipsNum++;
                else
                    correctNum++;
            });
        }
        if (!this.progressData.key_value)
            this.progressData.key_value = {};
        // 正解数:当月の設問に正解した総数
        this.progressData.key_value.correct_num = String(correctNum);
        // ヒントで読めた数:当月の設問にヒントありで正解した総数
        this.progressData.key_value.tips_num = String(tipsNum);
        // 達成済みのステージ数番号を更新
        this.progressData.key_value.stage_num = String(this.getCompletedStageNum());
    };
    /**
     * 達成済みのステージ数番号（５ステージ終えていたら5が返却される）
     *
     * @return {*}  {number} 達成済みのステージ数
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.getCompletedStageNum = function () {
        var completeStageNum = 0;
        var lastAnswerNum = this.getlastAnswerNum();
        if (lastAnswerNum) {
            completeStageNum = Math.floor(lastAnswerNum / this.questionNum);
        }
        return completeStageNum;
    };
    /**
     * 回答済みの最後の問題番号
     *
     * @return {*}  {number} 回答済みの最後の問題番号
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.getlastAnswerNum = function () {
        var maxIndex = 0;
        if (this.resultData.key_value) {
            var kv = this.resultData.key_value;
            Object.keys(kv).forEach(function (key) {
                // 数字を取り出す
                var indexStr = key.replace(/[^0-9]/g, '');
                if (indexStr) {
                    var index = parseInt(indexStr, 10);
                    // 最大値を求める
                    if (index > maxIndex)
                        maxIndex = index;
                }
            });
        }
        return maxIndex;
    };
    /**
     * update_atを更新
     *
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.updateUpdateAt = function (update_at) {
        if (!this.resultData.key_value)
            this.resultData.key_value = {};
        this.resultData.key_value.update_at = update_at;
    };
    /**
     * 取り組み結果の登録
     *
     * @param {number} index 問題番号（開始番号：1）
     * @param {string} kana 問題ひらがな文字 ex) あ
     * @param {number} result ヒントありか、なしか（正解:1 ヒントあり:2）
     * @param {number} answer 選択肢番号 ex) 1
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.setResult = function (index, kana, result, answer) {
        var _this = this;
        if (!this.resultData.key_value)
            this.resultData.key_value = {};
        this.resultData.key_value['kana' + '_' + index] = kana;
        this.resultData.key_value['result' + '_' + index] = String(result);
        this.resultData.key_value['answer' + '_' + index] = String(answer);
        // 月号深度情報を更新する
        // 連続して呼び出された場合、処理が余計なので1msec開ける
        if (this.updateProgressTimer)
            clearTimeout(this.updateProgressTimer);
        this.updateProgressTimer = setTimeout(function () {
            _this.updateProgress();
        }, 1);
    };
    /**
     * すべての登録を削除（月号深度情報、取り組み結果情報）
     *
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.deleteAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var param;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        param = {
                            app_id: this.app_id,
                            user_key: this.authinsideid,
                            key_values: [this.progressData, this.resultData],
                        };
                        if (param.user_key == undefined)
                            delete param.user_key;
                        return [4 /*yield*/, this.csbskvs.delete(param)
                            // 初期化
                        ];
                    case 1:
                        _a.sent();
                        // 初期化
                        this.progressData = {
                            data_name: this.progressDataName,
                        };
                        this.resultData = {
                            data_name: this.resultDataName,
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * オブジェクトを表す文字列を返します
     *
     * @return {*}  {void}
     * @memberof CsBsKvsHiraganaQuiz
     */
    CsBsKvsHiraganaQuiz.prototype.toString = function () {
        var param = {
            app_id: this.app_id,
            user_key: this.authinsideid,
            key_values: [this.progressData, this.resultData],
        };
        if (param.user_key == undefined)
            delete param.user_key;
        return JSON.stringify(param, null, '\t');
    };
    return CsBsKvsHiraganaQuiz;
}());
exports.CsBsKvsHiraganaQuiz = CsBsKvsHiraganaQuiz;
//# sourceMappingURL=CsBsKvsHiraganaQuiz.js.map